import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';

// Resources
import { resetFirstChildMarginTop } from '@/css/resources/placeholders.css';
import { fontStyle, fluidMargin } from '@/css/resources/mixins.css';

const getDynamicStyles = (formStyles) =>
	cssObj(
		fluidMargin({
			top: [
				formStyles?.section?.margin?.top[0] -
					formStyles?.input?.margin?.bottom[0],
				formStyles?.section?.margin?.top[1] -
					formStyles?.input?.margin?.bottom[1],
			],
		}),
		{
			'.supt-formSectionBreaker__title': fontStyle({
				...formStyles?.section?.title?.typography,
				textAlign: formStyles?.section?.title?.textAlignment,
				color: formStyles?.section?.title?.color,
			}),
		}
	);

const getStyles = (formStyles) =>
	css(resetFirstChildMarginTop, getDynamicStyles(formStyles), {
		gridColumn: 'span 12',
	});

// edit
const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/form-section-breaker"]': cssObj({
			marginLeft: '16px !important',
			marginRight: '16px !important',
			paddingBottom: '16px !important',
		}),
	});

export { getStyles, getEditGlobalStyles };
